<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style lang="less">
@import "../static/css/font_536444_etwajn5nrs9bpgb9.css";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
.position {
  display: block;
  width: 40%;
  margin: 80px auto 0;
}
@import "./common/style/reset.less";
@import "./common/style/common.less";
@import "./style/font.css";
</style>



// WEBPACK FOOTER //
// src/App.vue